import { DateFormat, ds } from '@/plugins/i18nFormat'
import EventBoat from '@model/EventBoat'
import EventRace from '@model/EventRace'
import { Model } from 'pinia-orm'
import { DateCast } from 'pinia-orm/casts'
import { Attr, BelongsTo, Cast, Num, Uid } from 'pinia-orm/decorators'

export default class EventRound extends Model {
    static entity = 'events-rounds'

    @Uid()
    declare id: string
    @Uid()
    declare eventId: string // only for sharding
    @Uid()
    declare eventRaceId: string
    @BelongsTo(() => EventRace, 'eventRaceId')
    declare race: EventRace
    @Uid()
    declare eventBoatId: string
    @BelongsTo(() => EventBoat, 'eventBoatId')
    declare boat: EventBoat
    @Num(0)
    declare round: number
    @Num(0)
    declare counter: number
    @Cast(() => DateCast) @Attr('')
    declare ts: Date | null

    get dump() {
        return {
            eventBoatId: this.eventBoatId,
            _boat: { country: this.boat?.country, sailNumber: this.boat?.sailNumber },
            round: this.round,
            counter: this.counter,
            ts: this.ts === null ? null : ds(this.ts, DateFormat.System),
        }
    }

    static piniaOptions = {
        persist: false,
    }
}
